import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, CATEGORIES } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const [products, setProducts] = useState(null);

  useEffect(() => {
    setProducts(null);
    api.get("/products", { params: category ? { category } : {} }).then((r) => setProducts(r.data));
  }, [category]);

  const pill = (active) =>
    `shrink-0 rounded-full border-2 px-5 py-2.5 text-sm font-extrabold transition-colors ${active ? "border-[var(--pink)] bg-[var(--pink)] text-white" : "border-white/20 text-white/80 hover:border-[var(--blue-soft)]"}`;

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-14" data-testid="shop-page">
      <p className="font-script text-xl text-[var(--blue-soft)]">Bake · Love · Enjoy</p>
      <h1 className="text-4xl sm:text-6xl">The Treat Shop</h1>
      <div className="no-scrollbar -mx-4 mt-6 flex gap-2 overflow-x-auto px-4 pb-1 sm:mx-0 sm:mt-8 sm:flex-wrap sm:gap-3 sm:px-0" data-testid="category-filter">
        <button className={pill(!category)} onClick={() => setParams({})} data-testid="category-filter-all">All</button>
        {CATEGORIES.map((c) => (
          <button key={c} className={pill(category === c)} onClick={() => setParams({ category: c })}
            data-testid={`category-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}>{c}</button>
        ))}
      </div>
      <div className="mt-6 grid grid-cols-2 gap-3 sm:mt-10 sm:gap-6 lg:grid-cols-3 xl:grid-cols-4" data-testid="product-grid">
        {products === null && [...Array(4)].map((_, i) => <div key={i} className="panel aspect-[3/4] animate-pulse" />)}
        {products?.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
      {products?.length === 0 && <p className="mt-10 text-white/60" data-testid="shop-empty">No treats in this category yet. Check back soon!</p>}
    </div>
  );
}
